<template>
  <!-- 数据下载 -->
  <div class="files-list-container">
    <div class="file-type-box">
      <div class="files-list-title">
        <img src="../../../assets/image/file_icon.svg" alt="" />
        <div class="files-type">
          {{ props.fileList.filesType }}<span v-if="!aiFailed">（{{ props.fileList.files.length }}）</span> 
        </div>
      </div>
      <div class="file-icons-wrap">
        <xl-icon :size="28" @click.stop="handleAddFilesPreprintList( fileList.files )" v-if="platform === 'dental' && $store.state.hasSlicePower && fileList.files.some(( f ) => f.printSupport )" class="print-icon">
          <PrinterList></PrinterList>
        </xl-icon>
        <xl-checkbox
          v-model="checkFilesType"
          :indeterminate="isFilesIndeterminate"
          @change="handleCheckFilesType"
          v-if="!aiFailed"
        >
        </xl-checkbox>
      </div>
    </div>
    <xl-checkbox-group v-model="checkedFiles" @change="handleCheckedFile">
      <div class="file-box" v-if="attachType === 'full_ai_design' && status === 'failed'">
        <div class="file-line"></div>
        <div class="file-name-box" >
          <div class="file-info">
            <img src="../../../assets/image/file-fail.svg" class="fail-img" alt="" />
            <div class="file-type" style="color: red">
                <!-- todo 根据错误码展示报错 -->
              {{ $t('design.download.aifail') }}
            </div>
          </div>
        </div>
      </div>
      <div
        v-else
        class="file-box"
        v-for="file in props.fileList.files"
        :key="file.fileType"
      > 
        <div class="file-line"></div>
        <div class="file-name-box" @click="clickFile(file.id)">
          <div class="file-info">
            <img src="../../../assets/image/downfile.svg" alt="" />
            <div class="file-type">
                {{ file.fileType }}--
                <xl-tooltip :content="file.filename" placement="top" :offset="2">
                  <span class="file-name">{{ file.filename }}</span>
                </xl-tooltip>
            </div>
          </div>
          <div class="file-type file-name create-time">
            {{ file.createOn }}
            <!-- <div class="file-icons-wrap" v-if="platform === 'dental'">
              <div v-if="file.fileTypeKey === 'resultModel'" class="print-icon">
                <xl-tooltip :content="$tapp('user.case.toPrint')" placement="top" :offset="2">
                  <xl-icon :size="28" @click.stop="handlePrintOutMessageBox(file)">
                    <Accuwaregreen v-if="file.hasPrinted"></Accuwaregreen>
                    <Accuwaregray v-else></Accuwaregray>
                  </xl-icon>
                </xl-tooltip>
              </div>
              <div v-if="$store.state.hasSlicePower && file.printSupport" class="print-icon">
                <xl-tooltip :content="$tapp('splint.addPrintList')" placement="top" :offset="2">
                  <xl-icon :size="28" @click.stop="handleAddPreprintList(file)" :disabled="file.hasWaitingPrint">
                    <PrinterListgreen v-if="file.hasPrinted"></PrinterListgreen>
                    <PrinterList v-else></PrinterList>
                  </xl-icon>
                </xl-tooltip>
              </div>
            </div> -->
          </div>
        </div>
        <xl-checkbox :label="file.id" :value="file.id"
          >{{}}
        </xl-checkbox>
      </div> 
    </xl-checkbox-group>
    <softwareEvoke ref="softwareEvokeRef"></softwareEvoke>
  </div>
</template>
<script setup>
import {
  XlScrollbar,
  XlButton,
  XlDivider,
  XlCheckbox,
  XlCheckboxGroup,
  XlMessageBox,
  XlTooltip,
  XlIcon
} from "@shining3d/ui-components";
import { Accuwaregray, Accuwaregreen, PrinterList, PrinterListgreen  } from '@shining3d/icons-vue'; 
import { ref, computed, watch } from "vue";
import { useLang } from "@shining3d/common-module/utils/lang.js";
import orderApi from '../../../api/order/index.js';
import { $setLocalStorage, $getLocalStorage } from '@shining3d/common-module/utils/index.js';
import softwareEvoke from '../../../components/softwareEvoke/index.vue';
import _get from 'lodash/get';
import debounce from "lodash/debounce";
import { useStore } from "vuex";
import router from '@/router';
import Bus from '../../../utils/bus.js';

const { $t } = useLang("@shining3d/xl-design-order");
const { $t: $tapp } = useLang( '@shining3d/app' );
const $store = useStore();
const route = router.currentRoute.value;
const institutionId = _get( $store, 'state.factorySelect.id', '' );
// const orderID = computed(() => _get( route, 'params.id', '' ));

const AI_FILE_TYPES = ['ai_design_preview',  'ai_design_exocad', 'ai_design_stl'];

const props = defineProps({
  fileList: {
    type: Object,
  },
  checkAll: {
    type: Boolean,
    default: false
  },
  checkedFilesList: {
    type: Array
  },
  orderID: {
    type: String
  },
  platform: {
    type: String,
    default: 'dental'
  }
});
const status = computed(() => props.fileList.status)
const attachType = computed(() => {
  if(AI_FILE_TYPES.includes(props.fileList.attachType)) {
    return 'full_ai_design'
  } else {
    return props.fileList.attachType
  }
})

const aiFailed = computed(()=> props.fileList.status === 'failed' && attachType.value === 'full_ai_design');
console.log( props.fileList, 'props.fileList=====', props.platform )
const emit = defineEmits(['changeFileList']);
// const filesListID = computed(() => props.fileList.files.map((i) => i.id) ) 
// 全选
// 勾选文件类型
const checkFilesType = ref(false);
const isFilesIndeterminate = ref(false);

const checkedFiles = ref([]);

// 选择文件
const handleCheckedFile = () => {
    const filesListID = props.fileList.files.map((i) => i.id)
    const checkedCount = checkedFiles.value.length;
    checkFilesType.value = checkedCount === filesListID.length;
    isFilesIndeterminate.value = checkedCount > 0 && checkedCount < filesListID.length;
};

// 点击文件
const clickFile = (id) => {
    const index = checkedFiles.value.indexOf(id); 
    if(index > -1){
        checkedFiles.value.splice(index, 1);
    } else {
        checkedFiles.value.push(id);
    }
    handleCheckedFile();
}
const handleCheckFilesType = (val) => {
  const filesList = attachType.value === 'full_ai_design' && status.value === 'failed' ? [] : props.fileList.files.map((i) => i.id)
  checkedFiles.value = val ? filesList : [];
  isFilesIndeterminate.value = false;
};

// watch(()=> props.checkAll,(val)=>{
//     if(val){
//         handleCheckFilesType(true);
//         checkFilesType.value = true;
//     } 
//     // else{
//     //     handleCheckFilesType(false);
//     //     checkFilesType.value = false;
//     // }
// })

const softwareEvokeRef = ref( null );
const handlePrintOutMessageBox = ( data ) => {
	$setLocalStorage( 'uninstallIsShow', false );
  const info = data.hasPrinted ? {
    title: $tapp( 'user.case.printConfirm' ),
    message: $tapp( 'user.case.secondaryPrintConfirmTips' )
  } : {
    title: $tapp( 'user.case.printConfirm' ),
    message: $tapp( 'user.case.printConfirmTips' )
  }
  XlMessageBox({
			type: 'info',
			title: info.title,
			message: info.message,
			confirmButtonText: $tapp( 'button.determine' ),
			cancelButtonText: $tapp( 'button.cancel' )
		}).then(() => {
      softwareEvokeRef.value.handlePrintOut({
        orgID: institutionId,
        orderID: props.orderID || route?.params?.id,
        fileID: [ data?.id ]
      })
		});
};

// 添加整设计结果文件至待打印列表
const handleAddFilesPreprintList = debounce(( files ) => {
  const data = {
    attachs: files.filter(( file ) => file.printSupport ).map(( file ) => ({
      srcID: file.orderID,
      srcAttachID: file.id
    }))
  };
  Bus.$emit( 'addPreprintItem', data );
}, 800 );

// 添加至待打印列表
const handleAddPreprintList = debounce(( file ) => {
  const data = {
    attachs: [{
			srcID: file.orderID,
			srcAttachID: file.id
		}]
  }
  if ( file.hasWaitingPrint ){
    return;
  } else if ( file.hasPrinted ){
    XlMessageBox({
			type: 'info',
			title: $tapp( 'common.prompt' ),
			message: $tapp( 'user.case.secondaryAddSliceConfirmTips' ),
			confirmButtonText: $tapp( 'button.determine' ),
			cancelButtonText: $tapp( 'button.cancel' )
		}).then(() => {
      Bus.$emit( 'addPreprintItem', data );
		});
  } else {
    Bus.$emit( 'addPreprintItem', data );
  }
}, 800 );

defineExpose({ checkedFiles, handleCheckFilesType, checkFilesType });
</script>
<style lang="scss" scoped>
.files-list-container {
  .file-type-box {
    height: 36px;
    padding: 6px 16px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #f7f8fa;
  }
  .files-list-title {
    display: flex;
    align-items: center;
    .files-type {
      font-size: 14px;
      font-weight: 500;
      line-height: 22px;
      color: #42526e;
      margin-left: 6px;
    }
  }
  .file-box {
    height: 38px;
    //   width: 100%;
    border-radius: 6px;
    display: flex;
    padding-right: 8px;
    align-items: center;
    &:hover {
      background: #edf3ff;
    }
    .file-line {
      width: 2px;
      height: 36px;
      background: #eff1f7;
      margin: 0 16px 0 24px;
    }
    .create-time {
      display: flex;
      align-items: center;
      justify-content: space-between;
      min-width: 280px;
      width: 280px;
      // margin-right: 160px;
    }
  }
  .file-name-box {
    width: 100%;
    height: 38px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    overflow: hidden
  }
  .file-info {
    display: flex;
    align-items: center;
    overflow: hidden;
  }
  .fail-img {
    width: 16px;
  }
  .file-type {
    font-size: 14px;
    font-weight: 500;
    line-height: 22px;
    margin-left: 6px;
    color: #2c364e;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .file-name {
    font-weight: 400 !important;
    color: #737e99 !important;
  }
  .file-icons-wrap {
    display: flex;
    align-items: center;
    .print-icon {
      color: #42526E;
      margin-right: 12px;
      .xl-icon {
        display: inline-block;
      }
      .xl-icon[disabled=true]{
        border: none;
        opacity: .5;
      }
    }
  }
  :deep(.el-checkbox) {
    height: 38px !important;
  }
}
</style>
